<div class="view-selector">
  <span>{{ "feed-views.label.data-view" | translate }}:</span>
  @for (view of availableViews; track view) {
    <sui-button
      variant="legacy-ghost"
      size="sm"
      [leadingIcon]="view.icon"
      [iconOnly]="true"
      [ariaLabel]="view.name"
      [pressed]="view.selected"
      (click)="toggleSelect(view.name, !view.selected)"
    ></sui-button>
  }
</div>
